export class PersonalityMenu {
  constructor() {
    this.bindEvents();
    this.getData();
  }

  init(e) {
    if (e.matches) {
      $('.header-menu--personality--toggle').off();
      var $modal = $('.header-menu--personality--modal');
      $modal.addClass('inactive');
      $('.header-menu--personality--toggle').on('click', function (e) {
        e.preventDefault();
        var mainCanvas = document.getElementById('header');
        var offsetTop = mainCanvas.offsetTop + 50;
        var offsetRight =
          window.innerWidth - (this.offsetLeft + this.offsetWidth);
        $modal.css({ top: offsetTop, right: offsetRight });
        $modal.removeClass('inactive');
        $(this).parent().addClass('open');
        $('body').css({ overflow: 'hidden' });
        $(this).attr('aria-expanded', true);
        $('.header-menu--personality--close').focus();
      });

      $(
        '.header-menu--personality--overlay, .header-menu--personality--close'
      ).on('click', function (e) {
        e.preventDefault();
        $('.header-menu--personality').removeClass('open');
        $('body').css({ overflow: 'auto' });
        $modal.one('transitionend', function () {
          $modal.addClass('inactive');
        });
        $('.header-menu--personality--toggle').attr('aria-expanded', false);
      });
    } else {
      $('.header-menu--personality--toggle').off();
      $('.header-menu--personality--toggle').on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('open');
      });
    }
  }

  bindEvents() {
    $('.header-menu--personality .level-1 > a').on('click', function (e) {
      e.preventDefault();
      var personalityId = $(this).parent().attr('data-personality');
      window.localStorage.setItem('personality', personalityId);
      $('.header-menu--personality--toggle').addClass('selected');
      $('.header-menu--personality .heading span').hide();
      $('.header-menu--personality .heading a').show();
      $('[data-personality]')
        .not('[data-personality="' + personalityId + '"]')
        .hide();
      $('[data-personality="' + personalityId + '"] > a').hide();
      var personalityTitle = $('[data-personality="' + personalityId + '"] > a')
        .first()
        .text();
      $('.header-menu--personality--modal .personality').text(
        ' ' + personalityTitle
      );
      var personalityMenu = $(
        '[data-personality="' + personalityId + '"] ul'
      ).show();
      $('.header-menu--personality--close').focus();
    });

    $('.header-menu--personality .heading a').on('click', function (e) {
      e.preventDefault();
      $('.header-menu--personality .heading span').show();
      $('.header-menu--personality .heading a').hide();
      $('[data-personality], [data-personality] > a').show();
      $('.header-menu--personality--modal .personality').text('');
      $('[data-personality] ul').hide();
      window.localStorage.removeItem('personality');
      $('.header-menu--personality--toggle').removeClass('selected');
      $('.header-menu--personality--close').focus();
    });
  }

  getData() {
    var personalityId = window.localStorage.getItem('personality');
    if (personalityId) {
      $('.header-menu--personality--toggle').addClass('selected');
      $('.header-menu--personality .heading span').hide();
      $('.header-menu--personality .heading a').show();
      $('[data-personality]')
        .not('[data-personality="' + personalityId + '"]')
        .hide();
      $('[data-personality="' + personalityId + '"] > a').hide();
      var personalityTitle = $('[data-personality="' + personalityId + '"] > a')
        .first()
        .text();
      $('.header-menu--personality--modal .personality').text(
        ' ' + personalityTitle
      );
      var personalityMenu = $(
        '[data-personality="' + personalityId + '"] ul'
      ).show();
    }
  }
}
